/**
 * Generate a random 4-digit PIN (1000-9999) using crypto when available.
 */
export const generateSecureFourDigitPin = (): string => {
  const min = 1000
  const range = 9000

  const cryptoObj: Crypto | undefined =
    typeof globalThis !== 'undefined' && 'crypto' in globalThis
      ? (globalThis.crypto as Crypto)
      : undefined

  if (!cryptoObj || typeof cryptoObj.getRandomValues !== 'function') {
    return String(Math.floor(min + Math.random() * range))
  }

  const array = new Uint32Array(1)
  const maxUint32 = 0xffffffff
  const limit = maxUint32 - (maxUint32 % range)

  for (let i = 0; i < 10; i++) {
    cryptoObj.getRandomValues(array)
    if (array[0] < limit) {
      return String(min + (array[0] % range))
    }
  }

  cryptoObj.getRandomValues(array)
  return String(min + (array[0] % range))
}
